import { throttle } from 'lodash';
import { isOverBreakpoint } from '../components/utility';

export function setActiveSlide() {
    if (!isOverBreakpoint('md') || $('.pdpCarousel.fullscreen').length > 0) return;
    $('.carousel-inner .carousel-item').reverse().each((index, element) => {
        const imageCenter = $(element).offset().top - $(element).height() / 2;
        if ($(window).scrollTop() >= imageCenter) {
            const currentIndex = $(element).index('.carousel-item');
            $(element).closest('.carousel').carousel(currentIndex);
            return false;
        }

        return true;
    });
}

export function scrollImageOnHover($img, mousePosition) {
    const $container = $img.closest('.carousel-item');
    const containerHeight = $container.height();
    // calc transition based on the ratio of the mouse position to the container height
    // and the effective scrollable img height
    const translateY = Math.max((mousePosition / containerHeight) * ($img.height() - containerHeight), 0);

    // Apply transition
    $img.css('--mouse-y', `${-translateY}px`);
}

export default class PdpCarousel {
    constructor() {
        this.body = $('body');
        this.fullStickyHeaderHeight = 0;
    }

    init() {
        // implement reverse function for jQuery
        jQuery.fn.reverse = function (...args) {
            return this.pushStack(this.get().reverse(), ...args);
        };
        this.scrollToImage();
        this.setActivePage();
        this.onSlideChangeEvent();
        this.calcFullStickyHeaderHeight();
        $(window).on(
            'resize',
            throttle(() => {
                this.calcFullStickyHeaderHeight();
                setActiveSlide();
            }, 100),
        );
        $('.header-banner .close').on('click', this.calcFullStickyHeaderHeight.bind(this));
        this.fullscreenCarousel();
    }

    scrollToImage() {
        const self = this;
        this.body.on('click', '.pdpCarousel-thumbs__dot', (e) => {
            if (isOverBreakpoint('md')) {
                e.preventDefault();
                const $target = $(e.currentTarget);
                const slideIndex = $(e.currentTarget).data('index');
                const $carousel = $($target.data('target'));
                if ($carousel.closest('.pdpCarousel').hasClass('fullscreen')) {
                    $carousel.carousel(slideIndex);
                } else {
                    const $carouselSlide = $(
                        $carousel.find('.carousel-item').get(slideIndex),
                    );
                    const scrollTo = $carouselSlide.offset().top
                        - self.fullStickyHeaderHeight;
                    window.scrollTo({
                        behavior: 'smooth',
                        top: scrollTo,
                    });
                }
            }
        });
    }

    onSlideChangeEvent() {
        this.body.on('slide.bs.carousel', '.pdpCarousel .carousel', (e) => {
            const $currentSlide = $(e.relatedTarget);
            const $thumb = $(`.pdpCarousel-thumbs__dot[data-index="${$currentSlide.index()}"]`);
            $thumb.addClass('active').siblings().removeClass('active');
        });
    }

    setActivePage() {
        $(window).on(
            'scroll',
            throttle(setActiveSlide.bind(this), 200),
        );
    }

    calcFullStickyHeaderHeight() {
        this.fullStickyHeaderHeight = ($('.sticky-breadcrumb').outerHeight() || 0)
            + ($('.main-header.sticky').outerHeight() || 0);
    }

    fullscreenCarousel() {
        this.body.on('click', '.pdpCarousel .carousel-item .img-fluid', (e) => {
            e.preventDefault();
            const $parentCarouselWrapper = $(e.currentTarget).closest(
                '.pdpCarousel',
            );
            if (!$parentCarouselWrapper.hasClass('fullscreen')) {
                $parentCarouselWrapper.addClass('fullscreen');
                this.body.addClass('modal-open');
            } else if (isOverBreakpoint('lg')) {
                $parentCarouselWrapper.toggleClass('zoom-in');
                const $img = $('.pdpCarousel.zoom-in .carousel-item .img-fluid');
                scrollImageOnHover($img, e.clientY);
            }
        });

        this.body.on(
            'mousemove',
            '.pdpCarousel.zoom-in .carousel-item .img-fluid',
            (e) => {
                const $img = $(e.currentTarget);
                scrollImageOnHover($img, e.clientY);
            },
        );

        this.body.on('click', '.pdpCarousel #exitFullscreen', (e) => {
            e.preventDefault();
            $('.pdpCarousel.zoom-in .carousel-item .img-fluid').css('--mouse-y', '0');
            $(e.currentTarget)
                .closest('.pdpCarousel')
                .removeClass('fullscreen zoom-in');
            this.body.removeClass('modal-open');
            setActiveSlide();
        });
    }
}
